module.exports = __webpack_public_path__ + "static/media/movie.351e628a.png";